module.exports = __webpack_public_path__ + "img/location.f2fc771e.svg";